import "../index.css";
import { ReactComponent as LogoIcon } from "../../../img/about/logo.svg";
import AlchemyBadge from "./AlchemyBadge";
import { SocialIconLinks } from "../../SocialIconLinks/SocialLinks";
import { NAV_LINKS } from "../../../config/consts";

export default function Footer() {
  return (
    <div className="about-footer d-flex flex-column">
      <div className="row">
        <div className="col-12 order-md-0 order-4">
          <LogoIcon className="footer-logo m-md-0 m-auto mt-5" />
          <div className="sp28"></div>
        </div>
        <div className="col-md-6 order-md-1 order-4">
          <div className="d-flex align-items-center align-items-md-start flex-column">
            <p className="footer-desc text-center text-md-start">
              Bebop is a crypto platform that makes trading in DeFi both easy and efficient. Trade
              many tokens at once with no slippage.
            </p>
            <div className="social-links">
              <SocialIconLinks />
            </div>
          </div>
        </div>
        <div className="col-md-3 mt-md-0 mt-5 order-md-2 order-0">
          <div className="d-flex flex-column align-items-center align-items-md-start">
            <a href={NAV_LINKS.FAQ} className="about-footer-link" target="_blank" rel="noreferrer">
              FAQs
            </a>
            <a
              href={NAV_LINKS.JOBS}
              className="about-footer-link mt-3"
              target="_blank"
              rel="noreferrer"
            >
              Join Us
            </a>
            <a
              href={NAV_LINKS.EMAIL}
              className="about-footer-link mt-3"
              target="_blank"
              rel="noreferrer"
            >
              Email
            </a>
            <a
              href={NAV_LINKS.BRAND}
              className="about-footer-link mt-3"
              target="_blank"
              rel="noreferrer"
            >
              Brand
            </a>
          </div>
        </div>
        <div className="col-md-3 mt-md-0 mt-5 order-md-3 order-1">
          <div className="d-flex flex-column align-items-center align-items-md-start">
            <a
              href={NAV_LINKS.TERMS_AND_CONDITIONS}
              target="_blank"
              rel="noreferrer"
              className="about-footer-link"
            >
              Terms & Conditions
            </a>
            <a
              href={NAV_LINKS.PRIVACY_POLICY}
              target="_blank"
              rel="noreferrer"
              className="about-footer-link mt-3"
            >
              Privacy Policy
            </a>
            <a
              href={NAV_LINKS.DOCUMENTATION}
              target="_blank"
              rel="noreferrer"
              className="about-footer-link mt-3"
            >
              Documentation
            </a>
            <AlchemyBadge />
          </div>
        </div>
      </div>
    </div>
  );
}
